import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isValidValue } from "utils/Utils";
import AppOutlineButton from "components/ui/AppOutlineButton";

const CancelOrder = ({ cancelOrder }) => {
  const { t } = useTranslation();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);

  if (
    isValidValue(
      orderInfo?.logisticPartnerMetadata?.IFAST?.trackingDeliveryInfo?.tracking_no
    )
  ) {
    return (
      <div>
        <div className="flex justify-center p-4">
          <AppOutlineButton variant="secondary" size="lg" onClick={cancelOrder}>
            {t("Cancel order with Ifast")}
          </AppOutlineButton>
        </div>
      </div>
    );
  } else if (orderInfo?.logisticPartnerMetadata?.IFAST?.deliveryStatus=== "Cancelled") {
    return (
      <div className="flex justify-center p-4">
        <div>{t("Order Has been Cancelled Already")}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-center p-4">
      <div>
        {t(
          "You haven’t sent your order to ifast delivery yet, you can send it by clicking SEND ORDER tab"
        )}
      </div>
    </div>
  );
};

export default CancelOrder;
